import axios from "axios";
import { logout } from "../Utils/HelpingFunction";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "/api",
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

axiosInstance.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
        config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
});


axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;

        if (status === 401) {
            logout();
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
